import { createAction } from '@reduxjs/toolkit';

/**
 * "Signal" actions: intents the UI dispatches for the saga to act on. Kept out
 * of the slice's reducers: they trigger side effects, not state transitions (the
 * saga owns the resulting `load*` / `mutation*` transitions).
 *
 * The header actions carry no id; the saga reads the current session id from
 * state (the buttons only render once the session has loaded). `retryErrors`
 * carries the specific target ids to re-enqueue.
 */

/** Start the live poll for a session id (dispatched by the page on mount). */
export const pollStarted = createAction<string>('sessionDetail/pollStarted');
/** Stop the live poll (page unmount, or after a settled action). */
export const pollStopped = createAction('sessionDetail/pollStopped');

export const pauseRequested = createAction('sessionDetail/pauseRequested');
export const resumeRequested = createAction('sessionDetail/resumeRequested');
export const retryRequested = createAction('sessionDetail/retryRequested');
export const cancelRequested = createAction('sessionDetail/cancelRequested');
export const resetRequested = createAction('sessionDetail/resetRequested');
export const retryErrorsRequested = createAction<string[]>('sessionDetail/retryErrorsRequested');
